exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scorer-signup-signup-form-Cq0bM{display:flex;flex-direction:column;align-items:center;width:50%;min-width:300px;padding-top:40px;padding-bottom:40px}.scorer-signup-input-fields-2zMKa{width:75%}.scorer-signup-login-row-tLhAF{margin-top:50px}.scorer-signup-error-text-1kYct{color:red}.scorer-signup-submit-button-14fFl{display:flex;justify-content:right}#spanish-proficient,.form-control{border:solid 1px var(--table-border)}", ""]);

// exports
exports.locals = {
	"signup-form": "scorer-signup-signup-form-Cq0bM",
	"signupForm": "scorer-signup-signup-form-Cq0bM",
	"input-fields": "scorer-signup-input-fields-2zMKa",
	"inputFields": "scorer-signup-input-fields-2zMKa",
	"login-row": "scorer-signup-login-row-tLhAF",
	"loginRow": "scorer-signup-login-row-tLhAF",
	"error-text": "scorer-signup-error-text-1kYct",
	"errorText": "scorer-signup-error-text-1kYct",
	"submit-button": "scorer-signup-submit-button-14fFl",
	"submitButton": "scorer-signup-submit-button-14fFl"
};